import React, { useState } from 'react';
import resources from '../../../services';
import Btn from '../../../ui/Btn';
import { Field } from '../../../ui/Field';
import CreatePage from '../../../composents/CreatePage';

const title = 'Countries';
const headers = {
	icon: 'feather icon-plus',
	title: title,
	description: 'creation of new country',
	breadcrumbs: [
		{
			title: title,
			link: '/hydrodrip/countries',
		},
	],
};

export default function CreateCountry() {
	const [loader, setLoader] = useState(false),
		[errors, setErrors] = useState({});

	/**
	 * @param {React.FormEvent<HTMLFormElement>} e
	 */
	async function onCreate(e) {
		e.preventDefault();
		let formData = new FormData(e.target);
		let object = {};
		formData.forEach((value, key) => (object[key] = value));
		setLoader(true);
		setErrors({});
		let res = await resources.country
			.create(object)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (res.status === 200) {
			sessionStorage.setItem('success', true);
			window.location.replace('/hydrodrip/countries');
		} else if (res.status === 422) {
			setErrors(
				res.data.errors.reduce((acc, error) => {
					return { ...acc, [error.field]: error.message };
				}, {})
			);
		} else if (res.status === 403) {
			setErrors({ not_autorized: true });
		}
		setLoader(false);
	}

	return (
		<CreatePage show_error={errors['not_autorized']} headers={headers}>
			<form onSubmit={onCreate}>
				<div className="row justify-content-center mt-3 mb-3">
					<div className="col-lg-6">
						<div className="card">
							<div className="card-header">
								<h5>Information</h5>
							</div>
							<div className="card-body">
								<Field
									name="name"
									className="mb-3"
									error={errors['name']}
									required
								>
									Country name
								</Field>

								<Field
									type="number"
									name="code_1"
									className="mb-3"
									error={errors['code_1']}
									required
								>
									Country code 1
								</Field>

								<Field
									name="code_2"
									className="mb-3"
									error={errors['code_2']}
									required
								>
									Country code 2
								</Field>

								<Field
									name="description"
									type="textarea"
									error={errors['description']}
									className="mb-3"
								>
									Description
								</Field>

								<div className="row ">
									<div className="col-lg-12">
										<div className="d-grid gap-2">
											<Btn
												className="btn waves-effect waves-light btn-primary"
												onLoad={loader}
											>
												<i className="feather icon-save"></i>{' '}
												Submit
											</Btn>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</CreatePage>
	);
}
